import Customer from './account/customer';
import {
    newModalFromString
} from './components/modal';

// function formatDate (date) {
//     return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
//         date.getFullYear();
// }

// function formatDateUS(date) {
//     return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' +
//         date.getFullYear();
// }

function formatDate (date, formatPattern) {
    if (formatPattern === 'dd-mm-yyyy') {
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
            date.getFullYear();
    } else if (formatPattern === 'mm-dd-yyyy') {
        return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' +
            date.getFullYear();
    } else if (formatPattern === 'yyyy年mm月dd日') {
        var dateParsed = (date.getFullYear() + '年' + ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日');
        return dateParsed;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    Customer.accountLoginForm();
    Customer.loginAndAssociateOrderWithLoyaltyCustomer();
    Customer.loginAndAssociateOrderWithCustomer();
    Customer.registerAndAssociateOrderForm();
    Customer.prepareLoyaltySubscriptionForm();
    Customer.forgotPassword();
    Customer.accountRegisterForm();
    Customer.accountLoyaltyForm();
    Customer.resendActivationEmail();
    Customer.socialLoginHandler();
    $(window).on('resize changed.zf.mediaquery', transformContainerMobile);
    transformContainerMobile();
    turnLoginImg();

    function transformContainerMobile() {
        if (!Foundation.MediaQuery.atLeast('medium')) {
            $('.js-transform-container').removeClass('grid-container');
            $('.js-transform-container').addClass('grid-container-fluid');
        }

        if (Foundation.MediaQuery.atLeast('medium')) {
            $('.js-transform-container').removeClass('grid-container-fluid');
            $('.js-transform-container').addClass('grid-container');
        }
    }

    $('.js-login-tabs li').on('click', turnLoginImg);

    function turnLoginImg() {
        $('#login-form-error').removeClass('success-block');
        if ($('.js-link-access').hasClass('current')) {
            $('.js-img-login-turn').show();
        } else {
            $('.js-img-login-turn').hide();
        }

        if ($('.js-link-register').hasClass('current')) {
            $('.js-img-registration-turn').show();
        } else {
            $('.js-img-registration-turn').hide();
        }
        $('.login-form-error').empty();
        $('.login-form-error').removeClass('login-form-error-block');
        $('.already-registered-1').removeClass('success-block');
        $('.already-registered-2').removeClass('success-block');
    }

    let formatPattern = $('.datepickerTriggerElement').data('date-format-pattern');

    $('.datepickerTriggerElement').fdatepicker({
        format: formatPattern,
        disableDblClickSelection: true,
        leftArrow: '<<',
        rightArrow: '>>',
        closeIcon: 'X',
        closeButton: false
    }).on('changeDate', function (ev) {
        let date = new Date(ev.date.valueOf() + ev.date.getTimezoneOffset() * 60000);
        var datestring = formatDate(date, formatPattern);
        $('#dpReg').val(datestring);
        $('.datepickerTriggerElement').data('date', datestring);
    });

    if ($('#dpReg').val() !== '') {
        let formattedDate = $('#dpReg').val();
        $('.datepickerTriggerElement').data('date', formattedDate);
    }

    $('.js-turn-to-register-tab').on('click', function () {
        $('#tab-login-cell, .js-link-access').removeClass('current');
        $('#tab-registration-cell, .js-link-register').addClass('current');
        turnLoginImg();
    });

    $('.scroll-top-registration').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: '0px'
        }, 600);
    });

    $('.js-modal-tooltip-opposition').hover(function() {
        var $target = $(this).closest('.info-icon').find('.tooltip');
        $target.css({
            'visibility':'visible',
            'opacity': '1'
        });
    }, function() {
        var $target = $(this).closest('.info-icon').find('.tooltip');
        $target.css({
            'visibility':'hidden',
            'opacity': '0'
        });
    });

    $('.close-button-info-popover').on('click', function (e) {
        $('.popover-remember-me').hide();
    });

    $('.cc-info-icon').on('click', function (e1) {
        e1.stopPropagation();
        $('.info-rememberme').toggleClass('hide');
        $('body').on('click.closeTooltipEvent', function (e) {
            if ($(e.target).hasClass('close-button-info-tooltip') || $(e.target).closest('.info-rememberme').length === 0) {
                $('.info-rememberme').addClass('hide');
                $('body').off('click.closeTooltipEvent');
            }
        });
    });

    $('.js-info-persistent').on('click', function (e1) {
        e1.stopPropagation();
        $('.info-rememberme').removeClass('hide');
        $('body').on('click.closeTooltipEvent', function (e) {
            if ($(e.target).hasClass('close-button-info-tooltip') || $(e.target).closest('.info-rememberme').length === 0) {
                $('.info-rememberme').addClass('hide');
                $('body').off('click.closeTooltipEvent');
            }
        });
    });

    $('.checkbox-label').on('click', function (e) {
        return false;
    });

    $('body').on('change', '#rememberMe', function (e) {
        if ($('#rememberMe').prop('checked')) {
            $('.popover-remember-me').hide();
        }
    });
});
